import script from "./ComprobantesContables.vue?vue&type=script&setup=true&lang=js"
export * from "./ComprobantesContables.vue?vue&type=script&setup=true&lang=js"

import "./ComprobantesContables.vue?vue&type=style&index=0&id=7c59924a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c59924a"]])

export default __exports__